import { TimelineItem, TimelineSkin } from './Timeline.types';

export type TimelineItemProps = {
  /** timeline event item index */
  idx: number;
  /** timeline event item */
  item: TimelineItem;
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  gap?: string;
  /** Sets the skin of the event item */
  skin?: TimelineSkin;
};
